import React from 'react';
import { PageSection, IconCheckGreen } from 'adc-ui-components';
import { Link } from 'react-router-dom';

import Card from '../../../components/Card';
import OrderDetails from '../../../components/OrderDetails';
import DeviceUpdateDetails from '../../../components/DeviceUpdateDetails';
import HowToReturnOldEquipment from '../../../components/HowToReturnOldEquipment';
import { getConfirmationDetails } from '../../../helpers/swaps';
import { RETURNS } from '../../../helpers/routes';

const status = (
  <span className="status status--warning">Order In Progress</span>
);


export default ({
  devices,
  account,
  macaroon,
}) => (
  <PageSection>
    <div className="text-center">
      <IconCheckGreen className="svg-icon--42 mb12" />
      <h1 className="heading2 mb24">Your order has been placed!</h1>
    </div>
    <OrderDetails
      title="Order details"
      details={getConfirmationDetails(account, macaroon)}
      action={status}
    >
      <div className="card-group__item">
        <Card className="card--secondary">
          <p>
            {'You can track your order from '}
            <Link href={RETURNS}>My Account</Link>
          </p>
        </Card>
      </div>
    </OrderDetails>

    <DeviceUpdateDetails devices={devices} />
    <HowToReturnOldEquipment className="mb24" />

    <div className="action action--centered">
      <a className="button" href="/">Back to My Account</a>
    </div>
  </PageSection>
);
